<template>
  <time v-if="value" :datetime="value">{{ formatted }}</time>
</template>

<script>
export default {
  name: 'Date',
  props: {
    value: String,
    options: Object
  },
  computed: {
    formatted() {
      if (!this.value) return;
      const date = new Date(this.value);
      return new Intl.DateTimeFormat('fr-CH', this.options).format(date);
    }
  }
};
</script>
